import { useState, useRef } from 'react';
import './PageStyles.css';

const FilmAnalysisPage = ({ documents, onUpload, onSelect }) => {
  const [dragOver, setDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      onUpload(files);
    }
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    if (files.length > 0) {
      onUpload(files);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Film Analysis</h1>
        <p className="page-subtitle">
          Deep explorations of cinematic technique, narrative structure, and visual storytelling
        </p>
      </div>

      <div
        className={`upload-zone ${dragOver ? 'drag-over' : ''}`}
        onDragOver={(e) => {
          e.preventDefault();
          setDragOver(true);
        }}
        onDragLeave={() => setDragOver(false)}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current?.click()}
      >
        <div className="upload-zone-icon">◇</div>
        <div className="upload-zone-text">Drop Markdown or HTML files here</div>
        <div className="upload-zone-hint">Supports .md, .markdown, .html, and .htm files</div>
        <input
          ref={fileInputRef}
          type="file"
          accept=".md,.markdown,.html,.htm"
          multiple
          style={{ display: 'none' }}
          onChange={handleFileSelect}
        />
      </div>

      {documents.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">◇</div>
          <div className="empty-state-text">No analyses yet</div>
          <div className="empty-state-hint">Upload your first film analysis to get started</div>
        </div>
      ) : (
        <div className="document-grid">
          {documents.map((doc, index) => (
            <div
              key={doc.id}
              className="document-card"
              onClick={() => onSelect(doc)}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="document-card-title">{doc.name.replace(/\.(md|markdown|html|htm)$/, '')}</div>
              <div className="document-card-meta">
                {new Date(doc.uploadDate).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </div>
              <div className="document-card-tags">
                <span className="tag">{doc.type}</span>
                <span className="tag">Analysis</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilmAnalysisPage;
